import { Alert } from 'reactstrap';

// Texts for the warning codes returned by /supplier/company_info/ai
const WARNING_MESSAGES = {
    website_not_found: 'No website of the company was found, so its VAT ID and register details could not be checked.',
    website_check_failed: 'The company\'s website could not be checked, so its VAT ID and register details were not filled in.',
    website_not_readable: 'The company\'s website could not be read, so its VAT ID and register details could not be checked.',
    legal_data_not_found: 'The company\'s website was read, but no VAT ID, registration number or address was found on it.',
    website_name_mismatch: 'The website found belongs to another company, so its data was not used:',
    country_mismatch: 'The company\'s website only lists an entity in another country, so its data was not used:',
};

const describeEntity = (entity) => {
    if (!entity) {
        return '';
    }

    const location = [entity.city, entity.country].filter(Boolean).join(', ');

    return [entity.legalName, entity.vatNumber, location].filter(Boolean).join(' · ');
};

const AiWarningsNotice = ({ t, warnings }) => {
    const known = (warnings || []).filter((warning) => WARNING_MESSAGES[warning?.code]);

    if (!known.length) {
        return null;
    }

    return (
        <Alert color="warning" className="ai-generated-form-section__warnings">
            {known.map((warning) => (
                <div key={warning.code}>
                    <i className="ri-error-warning-line me-1" />
                    {t(WARNING_MESSAGES[warning.code])}
                    {warning.websiteEntity && (
                        <strong className="ms-1">{describeEntity(warning.websiteEntity)}</strong>
                    )}
                </div>
            ))}
        </Alert>
    );
};

export default AiWarningsNotice;
